import {
  stableBuildResponseSchema,
  type StableBuildResponse,
} from '@/lib/schemas/dev/stable-build.schema';

// Frontend stable de dev : état et demande de recompilation (route réservée au serveur HMR de dev
// et aux super-admins ; ailleurs elle répond 404 et le bouton ne s'affiche pas).

export const devQueryKeys = {
  stableBuild: () => ['dev', 'stable-build'] as const,
};

async function parse(res: Response): Promise<StableBuildResponse> {
  if (res.status === 404 || res.status === 401 || res.status === 403) {
    return { ok: false, messageKey: 'unavailable' };
  }
  return stableBuildResponseSchema.parse((await res.json()) as unknown);
}

export async function fetchStableBuildStatus(): Promise<StableBuildResponse> {
  return parse(await fetch('/api/dev/stable-build', { cache: 'no-store' }));
}

export async function requestStableBuild(): Promise<StableBuildResponse> {
  return parse(await fetch('/api/dev/stable-build', { method: 'POST' }));
}
